import { CommonDialog, type UseModalState } from "@clipboard-health/ui-react";
import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { Text } from "@src/appV2/redesign/components/Text";
import { logout } from "@src/modules/session";

interface LogoutConfirmationDialogProps {
  modalState: UseModalState;
}

export function LogoutConfirmationDialog(props: LogoutConfirmationDialogProps) {
  const { modalState } = props;

  function handleLogout() {
    modalState.closeModal();
    logout();
  }

  return (
    <CommonDialog
      modalState={modalState}
      title="Confirm Logout"
      actions={
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button variant="outlined" onClick={modalState.closeModal}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleLogout}>
            Logout
          </Button>
        </Stack>
      }
    >
      <Text variant="body2">Are you sure you want to logout?</Text>
    </CommonDialog>
  );
}
